import React, {ChangeEvent, useState} from 'react';
import styles from './styles.module.scss';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

import {createTheme, ThemeProvider} from '@mui/material/styles';
import {PaginationItem} from "@mui/material";
import {RiArrowLeftLine, RiArrowRightLine} from "react-icons/ri";

const theme = createTheme({
    palette: {
        primary: {
            main: '#0041D9', // Cor de fundo selecionada
            contrastText: '#FFFFFF', // Cor do texto
        },
    },
    typography: {
        fontFamily: 'Mulish', // Fonte Mulish
    },
});

interface SEPaginationProps {
    color: string,
    linesPerPageFilters: number | string,
    linesPerPageOptions: number[],
    totalPages: number | undefined,
    currentPage: number,
    onLinesPerPageChange: (value: any) => void,
    onPagePreviousChange: (value: number) => void,
    onPageNextChange: (value: number) => void,
    onInputPageChange: (value: number) => void,
    onKeyPressChange: (value: string) => void,

}


export const SEPagination: React.FC<SEPaginationProps> = ({
                                                              color = '#555770',
                                                              linesPerPageFilters = 10,
                                                              linesPerPageOptions = [10, 25, 50, 100],
                                                              totalPages,
                                                              currentPage = 0,
                                                              onLinesPerPageChange = () => {
                                                              },
                                                              onPagePreviousChange = () => {
                                                              },
                                                              onPageNextChange = () => {
                                                              },
                                                              onKeyPressChange = () => {
                                                              },
                                                          }) => {
    const [selectedPage, setSelectedPage] = useState(currentPage + 1);

    function handleLinesPerPageChange(event: ChangeEvent<HTMLSelectElement>) {
        if (onLinesPerPageChange) {
            const newValue = Number(event.currentTarget.value);
            onLinesPerPageChange(newValue);
        }
    }

    function handlePageChange(event: React.ChangeEvent<unknown>, value: number) {
        if (value !== selectedPage) {
            setSelectedPage(value);
            if (value < selectedPage) {
                onPagePreviousChange(value - 1);
            } else {
                onPageNextChange(value - 1);
            }
        }
    }

    return (
        <div className={styles.paginationContainer}>
            <div>
                <label htmlFor="input-qtdPage">Linhas por página: </label>
                <select
                    style={{color: color}}
                    value={linesPerPageFilters}
                    onChange={handleLinesPerPageChange}
                >
                    {linesPerPageOptions.map((olp) => (
                        <option key={olp} value={olp}>
                            {olp}
                        </option>
                    ))}
                </select>
            </div>

            {/* SELETOR */}
            <div>
                <Stack spacing={1}>
                    <ThemeProvider theme={theme}>

                        <Pagination
                            count={totalPages}
                            page={selectedPage}
                            onChange={handlePageChange}
                            renderItem={(item) => {
                                if (item.type === 'previous' || item.type === 'next') {
                                    return (
                                        <PaginationItem
                                            {...item}
                                            shape="circular"
                                            color="primary"
                                            variant="outlined"
                                            components={{ previous: () => <RiArrowLeftLine size={14} />, next: () =>  <RiArrowRightLine size={14} /> }}
                                        />
                                    );
                                } else {
                                    return (
                                        <PaginationItem
                                            {...item}
                                            shape="rounded"
                                            color="primary"
                                            variant="outlined"
                                            style={{
                                                backgroundColor: item.selected ? '#0041D9' : '#FFFFFF',
                                                color: item.selected ? '#FFFFFF' : '#28293D',
                                                borderColor: item.selected ? '#0041D9' : '#EBEBF0',
                                            }}

                                        />
                                    );
                                }
                            }}
                        />

                    </ThemeProvider>
                </Stack>
            </div>
        </div>
    );
};
